// Return paths the student benefit landing uses in `next_url` when redirecting
// to login (`/estudantes` in prod, `/planos/estudantes` elsewhere), plus the
// query param it appends to auto-resume the flow after auth.
const STUDENT_BENEFIT_RETURN_PATHS = ['/estudantes', '/planos/estudantes']
const START_STUDENT_VALIDATION_PARAM = 'start-student-validation'

export function isStudentBenefitSignup(nextUrl?: string | null): boolean {
  if (!nextUrl) return false

  try {
    const url = new URL(nextUrl, 'https://www.jusbrasil.com.br')
    const pathMatches = STUDENT_BENEFIT_RETURN_PATHS.some(
      (path) => url.pathname === path || url.pathname.endsWith(path)
    )

    return pathMatches || url.searchParams.has(START_STUDENT_VALIDATION_PARAM)
  } catch {
    return false
  }
}
